import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AuthState from "./context/auth/AuthState";
import VideoState from "./context/video/VideoState";
import UserState from "./context/user/UserState";
//import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <AuthState>
    <VideoState>
      <UserState>
        <App />
      </UserState>
    </VideoState>
  </AuthState>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
